<!--  -->
<template>
  <div class=''>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>公司信息</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="mcDialogVisible = true">编辑</el-button>
          </div>
          <div class="content home-contact"
               style="padding:10px">

            <el-row :gutter="20">

              <el-col :span="6"
                      style="line-height: 22px;font-weight: 700;">
                发件邮箱：
              </el-col>
              <el-col :span="4"
                      style="line-height: 22px;font-weight: normal;text-align:left;">
                {{oldMail.sf}}
              </el-col>
              <el-col :span="4"
                      style="line-height: 22px;font-weight: normal;text-align:left;">
                {{oldMail.un}}
              </el-col>
              <el-col :span="4"
                      style="line-height: 22px;font-weight: normal;text-align:left;">
                {{oldMail.pw}}
              </el-col>

              <el-col :span="4"
                      style="line-height: 22px;font-weight: normal;text-align:left;">
                {{oldMail.st}}
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="6"
                      style="line-height: 22px;font-weight: 700;">
                收件邮箱：
              </el-col>

              <el-col :span="18"
                      style="line-height: 22px;font-weight: normal;">
                <div v-for="(item,index) in mail.receiveList">{{item}}</div>
              </el-col>
            </el-row>

          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <!-- <div slot="header" class="clearfix">
                        <span>联系我们</span>
                    </div> -->

          <div class='content'>

            <el-table :data="msgs"
                      style="width: 100%">
              <el-table-column prop="companyName"
                               label="公司名称"
                               align="center">
              </el-table-column>
              <el-table-column prop="named"
                               label="称呼"
                               width="180"
                               align="center">
              </el-table-column>
              <el-table-column prop="createTime"
                               label="提交时间"
                               align="center">
              </el-table-column>
              <el-table-column prop="content"
                               label="咨询内容"
                               width="180"
                               align="center">
              </el-table-column>
              <!-- <el-table-column prop="state"
                               label="状态"
                               width="70"
                               align="center">
              </el-table-column> -->

              <el-table-column fixed="right"
                               label="操作"
                               width="100"
                               align="center">
                <template slot-scope="scope">
                  <el-button @click="msgDialogVisible = true;selectMsg = scope.row;"
                             type="text"
                             size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="详情"
               :visible.sync="msgDialogVisible"
               width="1070px">

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3"
                class="headline">
          公司名称:
        </el-col>
        <el-col :span="5"
                class="data">
          {{selectMsg.companyName}}
        </el-col>
        <el-col :span="3"
                class="headline">
          称呼:
        </el-col>
        <el-col :span="5"
                class="data">
          {{selectMsg.named}}
        </el-col>
        <el-col :span="3"
                class="headline">
          邮箱地址:
        </el-col>
        <el-col :span="5"
                class="data">
          {{selectMsg.email}}
        </el-col>
      </el-row>

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3"
                class="headline">
          邮政编码:
        </el-col>
        <el-col :span="3"
                class="data">
          {{selectMsg.postcode}}
        </el-col>
        <el-col :span="3"
                class="headline">
          地址:
        </el-col>
        <el-col :span="15"
                class="data">
          {{selectMsg.address}}
        </el-col>

      </el-row>

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3"
                class="headline">
          电话号码:
        </el-col>
        <el-col :span="3"
                class="data">
          {{selectMsg.telephone}}
        </el-col>
        <el-col :span="3"
                class="headline">
          传真号码:
        </el-col>
        <el-col :span="5"
                class="data">
          {{selectMsg.faxNumber}}
        </el-col>
        <el-col :span="3"
                class="headline">
          咨询内容:
        </el-col>
        <el-col :span="5"
                class="data">
          {{selectMsg.content}}
        </el-col>
      </el-row>

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3"
                class="headline">
          咨询详情:
        </el-col>
        <el-col :span="21"
                class="data">
          {{selectMsg.details}}
        </el-col>
      </el-row>

    </el-dialog>

    <el-dialog title="编辑公司简介"
               :visible.sync="mcDialogVisible"
               width="1070px">

      <el-row :gutter="20"
              class="mail-set">
        <el-col :span="6">
          <span> 发件邮箱地址：</span>
        </el-col>
        <el-col :span="18">
          <el-input placeholder="请输入内容"
                    clearable
                    v-model="mail.sf">
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20"
              class="mail-set">
        <el-col :span="6">
          <span> 发件邮箱账号：</span>
        </el-col>
        <el-col :span="18">
          <el-input placeholder="请输入内容"
                    clearable
                    v-model="mail.un">
          </el-input>
        </el-col>
      </el-row>

      <el-row :gutter="20"
              class="mail-set">
        <el-col :span="6">
          <span> 发件邮箱密码：</span>
        </el-col>
        <el-col :span="18">
          <el-input placeholder="请输入内容"
                    clearable
                    v-model="mail.pw">
          </el-input>
        </el-col>
      </el-row>

      <el-row :gutter="20"
              class="mail-set">
        <el-col :span="6">
          <span> 发件邮箱SMTP：</span>
        </el-col>
        <el-col :span="18">
          <el-input placeholder="请输入内容"
                    clearable
                    v-model="mail.st">
          </el-input>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6"
                class="mail-set">
          <span> 收件邮箱地址：</span>
        </el-col>
        <el-col :span="18">
          <el-row class="mail-set"
                  v-for="(item,index) in mail.receiveList">
            <el-col :span="22">
              <el-input placeholder="请输入内容"
                        clearable
                        v-model="mail.receiveList[index]">
              </el-input>
            </el-col>
            <el-col :span="2"
                    style="text-align: center;">
              <a @click="delReceive(index)"
                 style="color: red;    cursor: pointer;">删除</a>
            </el-col>
          </el-row>

        </el-col>
      </el-row>
      <div class="Item-add">
        <a @click="addReceive">-
          新增收件邮箱 -</a>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="mcDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editMail">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      mcDialogVisible: false,
      msgDialogVisible: false,
      msgs: [],
      selectMsg: {},
      oldMail: {
          sf: "",
          un: "",
          pw: "",
          st: "",receiveList:[]
        
      },
      mail: {
          sf: "",
          un: "",
          pw: "",
          st: "",receiveList:[]
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    editMail() {
      var that = this;
      this.$request.post({
        url: "/api/admin/updateMail",
        params: that.mail,
        callback: {
          success: function(data) {
            that.mcDialogVisible = false;
            that.mail = data.data;
            that.oldMail = JSON.parse(JSON.stringify(data.data));
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    delReceive(index) {
      this.mail.receiveList.splice(index, 1);
    },
    addReceive() {
      this.mail.receiveList.push("");
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this;
    this.$request.get({
      url: "/api/pageData/admin/contact",
      callback: {
        success: function(data) {
          that.msgs = data.data.msgs;
          if (data.data.mail !== undefined) {
            that.mail = data.data.mail;
            that.oldMail = JSON.parse(JSON.stringify(data.data.mail));
          }
        },
        err: function(err) {
          console.log(err);
        }
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.mail-set {
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
  text-align: right;
}
.headline {
  text-align: right;
  font-weight: bold;
  color: #444 !important;
  letter-spacing: 0.1em;
  font-size: 96%;
}

.data {
  text-align: left;
}
</style>